import * as React from 'react';
import * as _ from 'lodash';
import * as moment from 'moment';
import { connect, Dispatch } from 'react-redux';
import { IMicrositeCampaignListing } from '@nkr/models/microsites';
import { IApplicationState, AppActionCreators, IMicrositeCampaignListResponse, MicrositeActionCreators, ICenterAddressListResponse, CenterActionCreators, IAppState } from '@nkr/store/index';
import { MicrositeType, OrganType } from '@nkr/enums/index';
import { Button, ControlLabel, FormControl, Glyphicon, OverlayTrigger, Well } from 'react-bootstrap';
import { CampaignAction } from './campaign-action';
import { IBaseResponse, ICenterAddress } from '@nkr/models/index';
import OrderBrochures from '../order-brochures';
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';
import DeleteCampaign from './delete-campaign';
import PopoverTemplate from '@nkr/components/popover-template';
import Grid from './grid';
import { downloadFile } from '@nkr/services/download-file';

interface IProps {
    centerId: number,
    isAdmin: boolean,
    isNkrLogin: boolean
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getMicrositeCampaignList: (centerId: number, micrositeType?: MicrositeType) => Promise<IMicrositeCampaignListResponse>,
    getCenterAddressList: (centerId: number) => Promise<ICenterAddressListResponse>,
    deleteMicrositeCampaign: (campaignId: number) => Promise<IBaseResponse>,
    orderCampaignBrochures: (id: number, orderCount: number, addressId: number) => Promise<IBaseResponse>,
    downloadCampaignPdf: (campaignId: number) => Promise<any>
}

type TProps = IStateProps & IDispatchProps & IProps

interface IState {
    data: IMicrositeCampaignListing[],
    delete: {
        show: boolean,
        data: IMicrositeCampaignListing
    },
    orderBrochures: {
        show: boolean,
        data: IMicrositeCampaignListing,
        centerAddressList: ICenterAddress[],
    },
    selectedCenterId: number,
    selectedCampaignType: number,
    showCampaignAlert: boolean,
    context: any,
    menuDisplayed: boolean
}

class CampaignList extends React.Component<TProps, IState> {
    readonly state: IState = {
        data: [],
        delete: {
            show: false,
            data: null
        },
        orderBrochures: {
            show: false,
            data: null,
            centerAddressList: []
        },
        selectedCenterId: 0,
        selectedCampaignType: 0,
        showCampaignAlert: true,
        context: { componentParent: this },
        menuDisplayed: false
    }

    componentDidMount = () => {
        const micrositeType = this.props.app.site.organType == OrganType.Liver ? MicrositeType.Liver : null;

        this.props.showLoading('Retrieving campaign list, one moment please...').then(() => {
            this.props.getMicrositeCampaignList(this.props.centerId, micrositeType).then((response: IMicrositeCampaignListResponse) => {
                if (response.data.success) {
                    let campaigns = response.data.results;

                    this.setState({
                        data: campaigns
                    });
                }

                this.props.hideLoading();
            });
        });
    }

    getBaseUrl = () => {
        if (this.props.isAdmin) {
            return '/admin';
        } else {
            return '/center/' + this.props.centerId;
        }
    }

    getFilteredData = () => {
        let filteredCampaigns = this.state.data.filter(item => {
            let typeFilter = true;

            if (this.state.selectedCampaignType == 1) {
                typeFilter = moment().isBetween(moment(item.startDate), moment(item.endDate));
            }

            if (this.state.selectedCampaignType == 2) {
                typeFilter = moment().isAfter(moment(item.endDate));
            }

            if (this.state.selectedCampaignType == 3) {
                typeFilter = moment().isBefore(moment(item.startDate));
            }

            let centerFilter = true;

            if (this.state.selectedCenterId > 0) {
                centerFilter = item.centerId == this.state.selectedCenterId;
            }

            if (this.state.selectedCenterId == -1) {
                centerFilter = item.centerId == null;
            }

            return typeFilter && centerFilter;
        });

        return filteredCampaigns;
    }

    getCenters = () => {
        let list = this.state.data.filter(x => x.centerId != null).map(x => {
            return { id: x.centerId, alias: x.centerAlias };
        });

        let unique = _.uniqBy(list, item => item.id);

        return _.sortBy(unique, item => item.alias);
    }

    handleMenuToggle = (show: boolean) => {
        this.setState({
            menuDisplayed: show
        });
    };

    handleMenuSelection = (eventKey: number, campaignId: number) => {
        if (eventKey == CampaignAction.Delete) {
            let campaign = this.state.data.find(x => x.id == campaignId);

            this.setState({
                delete: {
                    show: true,
                    data: campaign
                }
            });
        }

        if (eventKey == CampaignAction.OrderBrochures) {
            let campaign = this.state.data.find(x => x.id == campaignId);

            this.props.showLoading('One moment please...').then(() => {
                this.props.getCenterAddressList(campaign.centerId).then(response => {
                    this.props.hideLoading();

                    this.setState({
                        orderBrochures: {
                            show: true,
                            data: campaign,
                            centerAddressList: response.data.results
                        }
                    });
                });
            });
        }
    }

    handleCenterChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        var selectedCenterId = parseInt(e.currentTarget.value);

        this.setState({
            selectedCenterId
        });
    }

    handleCampaignTypeChange = (e: React.FormEvent<FormControl & HTMLSelectElement>) => {
        var selectedCampaignType = parseInt(e.currentTarget.value);

        this.setState({
            selectedCampaignType
        });
    }

    handleAddCampaign = () => {
        window.location.href = this.getBaseUrl() + '/microsite/campaign/0';
    }

    handleHideCampaignAlert = () => {
        this.setState({
            showCampaignAlert: false
        });
    }

    handleCancelDelete = () => {
        this.setState({
            delete: {
                show: false,
                data: null
            }
        });
    }

    handleDeleteCampaign = () => {
        var campaignId = this.state.delete.data.id;

        this.props.showLoading('Deleting Campaign, one moment please...').then(() => {
            this.props.deleteMicrositeCampaign(campaignId).then(response => {
                if (response.data.success) {
                    let data = _.cloneDeep(this.state.data).filter(x => x.id != campaignId);

                    this.setState({
                        data,
                        delete: {
                            show: false,
                            data: null,
                        }
                    });
                }

                this.props.hideLoading();
            }).catch(() => {
                alert('Error occured while attempting to delete.')
                this.setState({
                    delete: {
                        show: false,
                        data: null,
                    }
                })

            });
        });
    }

    handleOrderBrochures = (orderCount: number, addressId: number) => {
        let id = this.state.orderBrochures.data.id;

        this.setState({
            orderBrochures: {
                show: false,
                data: null,
                centerAddressList: []
            }
        }, () => {
            this.props.showLoading('Sending brochure request, one moment please...').then(() => {
                this.props.orderCampaignBrochures(id, orderCount, addressId)
                    .then(response => {
                        this.props.hideLoading();

                        if (response.data.success) {
                            toast.success('Brochure order saved successfully');
                        }
                    })
                    .catch((error: AxiosError) => {
                        this.props.hideLoading();
                        toast.error('Unable to save brochure order, the following error occurred: ' + error.message);
                    });
            });
        });
    }

    handleCancelBrochures = () => {
        this.setState({
            orderBrochures: {
                show: false,
                data: null,
                centerAddressList: []
            }
        });
    }

    handleGetCampaignPdf = (campaignId: number) => {
        this.props.downloadCampaignPdf(campaignId).then(response => {
            downloadFile(response.data, `campaign-${campaignId}.pdf`, 'application/pdf');
        });
    }

    render() {
        const data = this.getFilteredData();
        const centers = this.getCenters().filter(x => x.id != 0);

        return (
            <>
                <Well bsSize='sm'>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '33%' }}>
                            {this.props.isAdmin && (
                                <div style={{ display: 'flex', alignItems: 'center', marginRight: 10 }}>
                                    <ControlLabel style={{ marginBottom: 0, marginRight: 5 }}>Center:</ControlLabel>
                                    <FormControl
                                        componentClass='select'
                                        value={this.state.selectedCenterId}
                                        onChange={this.handleCenterChange}
                                    >
                                        <option value={0} selected>- All Centers -</option>
                                        <option value={-1} selected>- NO CENTER -</option>
                                        {centers.map(item =>
                                            <option key={'ctr-' + item.id} value={item.id} selected>{item.alias}</option>
                                        )}
                                    </FormControl>
                                </div>
                            )}

                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <ControlLabel style={{ marginBottom: 0, marginRight: 5 }}>Status:</ControlLabel>
                                <FormControl
                                    componentClass='select'
                                    value={this.state.selectedCampaignType}
                                    onChange={this.handleCampaignTypeChange}
                                >
                                    <option value={0} selected>- All Campaigns -</option>
                                    <option value={1}>Active Campaigns</option>
                                    <option value={3}>Future Campaigns</option>
                                    <option value={2}>Expired Campaigns</option>
                                </FormControl>
                            </div>
                        </div>

                        <div style={{ width: '33%' }}>
                            {this.props.isAdmin == false && (
                                <OverlayTrigger trigger='click' placement='right' rootClose overlay={
                                    <PopoverTemplate>
                                        <div>
                                            Microsite campaigns allow you to generate and give out a 6 character key that can then be used by recipients to self-register to your center during
                                            the date range that you specify. This can be used as part of a mail campaign and/or to avoid entering PHI into our system; this is left
                                            to the discretion of the patient. After the recipient registers with a campaign key, you just have to confirm that they are a
                                            patient at your center and their Starter Site will become activated.
                                        </div>
                                    </PopoverTemplate>
                                }>
                                    <Button bsStyle='info' bsSize='sm'>
                                        <Glyphicon glyph='info-sign' /> About Campaigns
                                    </Button>
                                </OverlayTrigger>
                            )}
                        </div>

                        <Button bsStyle='primary' className='pull-right' onClick={this.handleAddCampaign}>Add Campaign</Button>
                    </div>
                </Well>

                <Grid
                    data={data}
                    isAdmin={this.props.isAdmin}
                    onMenuSelection={this.handleMenuSelection}
                    onGetCampaignPdf={this.handleGetCampaignPdf} />

                <DeleteCampaign
                    show={this.state.delete.show}
                    campaignName={this.state.delete.data != null ? this.state.delete.data.campaignName : ''}
                    onDelete={this.handleDeleteCampaign}
                    onCancel={this.handleCancelDelete}
                />

                <OrderBrochures
                    show={this.state.orderBrochures.show}
                    campaignName={this.state.orderBrochures.data != null ? this.state.orderBrochures.data.campaignName : ''}
                    addressList={this.state.orderBrochures.centerAddressList}
                    onOrder={this.handleOrderBrochures}
                    onCancel={this.handleCancelBrochures}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        app: appState.app
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getMicrositeCampaignList: (centerId, micrositeType) => {
            return dispatch(MicrositeActionCreators.getMicrositeCampaignList(centerId, micrositeType));
        },
        getCenterAddressList: (centerId) => {
            return dispatch(CenterActionCreators.getCenterAddressList(centerId));
        },
        deleteMicrositeCampaign: (campaignId) => {
            return dispatch(MicrositeActionCreators.deleteCampaign(campaignId));
        },
        orderCampaignBrochures: (id, orderCount, addressId) => {
            return dispatch(MicrositeActionCreators.orderCampaignBrochures(id, orderCount, addressId));
        },
        downloadCampaignPdf: (campaignId) => {
            return dispatch(MicrositeActionCreators.downloadCampaignPdf(campaignId));
        },
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(CampaignList);
